module.exports = __webpack_public_path__ + "static/img/21746686305_.pic.c031675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/21746686305_.pic.png
// module id = CU0y
// module chunks = 11